export const PATHS = {
  LOGIN: '/',
  REGISTRATION: '/sign-up',
  CHATS: '/messenger',
  SETTINGS: '/settings',
  NOT_FOUND: '/404'
} as const;
